import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {PwaManagerService} from '@pwa';

@Injectable({
	providedIn: 'root',
})
export class PWAGuard implements CanActivate {
	private readonly pwaManagerService: PwaManagerService = inject(PwaManagerService);
	private readonly router: Router = inject(Router);

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		if (this.pwaManagerService.isPwaMode$()) {
			this.router.navigate(['app/select-form']);
			return false;
		} else {
			return true;
		}
	}
}
